export class ConfiguracoesModel {
  id: number;
  nome_sistema: string = '';
  nome_empresa: string = '';
  cnpj: string = '';
  telefone: string = '';
  email: string = '';
  site: string = '';
  endereco: string = '';
  numero: string = '';
  complemento: string = '';
  bairro: string = '';
  cidade: string = '';
  estado: string = '';
  cep: string = '';
  logo_painel: string = '';
  logo_pdf: string = '';
  logo_email: string = '';
  logo_dashboard: string = '';
  pdf_mi_cor_titulo_header: string = '#940002';
  pdf_mi_cor_secao: string = '#c8102e';
  pdf_mi_cor_borda_num: string = '#d92d20';
  pdf_mi_cor_fundo_num: string = '#fff5f5';
}



// WEBPACK FOOTER //
// ./src/app/configuracoes/configuracoes.model.ts